import {Route, Routes} from "react-router-dom";
import Workers from "../workers/Workers";
import Clients from "../clients/Clients";
import Navigation from "../../navigation/Navigation";
import Rajcompanies from "../rajcompanies/Rajcompanies";
import Buildings from "../buildings/Buildings";
import Teams from "../teams/Teams";
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import Footer from "../../navigation/Footer";
import Offers from "../offers/Offers";
import Calendar from "../calendar/Calendar";
import {useAuth} from "../../providers/authprovider";
import TodoModal from "./TodoModal";
import {useEffect, useRef, useState} from "react";
import Protocols from "../protocols/Protocols";
import ProvideRemember from "../../providers/rememberprovider";
import Assortments from "../assortments/Assortments";
import PrivilegeProvider from "../../providers/privilegeprovider";
import ProvideOfflineData from '../../providers/offline_data_provider';
import Devices from "../protocols/devices/Devices";
import Instructions from "../instructions/Instructions";
import Dashboard from "../dashboard/Dashboard";
import InvoicesPage from "../invoices/InvoicesPage";
import WorkTimePage from "../worktime/WorkTimePage";
import Settings from "../settings/Settings";
import OfferPrices from "../offerPrices/OfferPrices";



export default function  Main()  {

    const {user, todo} = useAuth();
    const [todos, setTodos] = useState(undefined);
    const [openModalTodo, setOpenModalTodo] = useState(false)
    const todosRequested = useRef(false);

    // Pobieramy listę TODO dokładnie raz na sesję. Ref (a nie sam stan) pilnuje,
    // żeby kolejne rendery nie wystrzeliwały requestu jeszcze zanim wróci
    // odpowiedź, a stan ustawiamy też przy błędzie - inaczej dla użytkownika
    // bez uprawnień (403) todos zostawało undefined i request leciał w kółko.
    useEffect(()=>{
        if(todosRequested.current)
            return;

        todosRequested.current = true;

        todo.get(({success, content})=>{
            setTodos(success ? [...content] : []);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleOpenTodo = ()=>{
        setOpenModalTodo(true)
    }

    return (
        <ProvideRemember>
            <PrivilegeProvider user={user}>
                
                <>
                    <Navigation onOpenTodo={handleOpenTodo}/>
                    <TodoModal show={openModalTodo} todos={todos} onHide={()=>setOpenModalTodo(false)}/>
                    <div className={"body"}>
                        {
                            user &&
                            <Routes>
                                <Route path="/" element={<Dashboard />} />
                                <Route path="/clients" element={<Clients privilege={user?.getPrivilege('clients')}  />} />
                                <Route path="/workers" element={<Workers privilege={user?.getPrivilege('workers')} />} />
                                <Route path="/buildings/*" element={<Buildings privilege={user?.getPrivilege('buildings')} />} />
                                <Route path="/teams" element={<Teams privilege={user?.getPrivilege('teams')} />} />
                                <Route path="/rajcompanies" element={<Rajcompanies privilege={user?.getPrivilege('rajcompanies')} />} />
                                <Route path="/offers/*" element={<Offers privilege={user?.getPrivilege('offers')} />} />
                                <Route path="/calendar/*" element={<Calendar privilege={user?.getPrivilege('calendar')} />} />
                                <Route path="/protocols/*" element={
                                    <ProvideOfflineData> 
                                    <Protocols privilege={user?.getPrivilege('protocols')} />
                                    </ProvideOfflineData>} 
                                />
                                <Route path="/devices" element={<Devices privilege={user?.getPrivilege('clients')}  />} />
                                <Route path="/instructions" element={<Instructions privilege={user?.getPrivilege('instructions')}  />} />
                                <Route path={"/assortments"} element={<Assortments privilege={user?.getPrivilege('assortments')} />} />
                                <Route path="/offer_price_list" element={<OfferPrices privilege={user?.getPrivilege('offer_price_list')} />} />
                                <Route path="/invoices/*" element={<InvoicesPage privilege={user?.getPrivilege('invoices')} />} />
                                <Route path="/worktime/*" element={<WorkTimePage privilege={user?.getPrivilege('worktime')} />} />
                                <Route
                                    path="/settings"
                                    element={user?.isAdmin ? <Settings /> : <Dashboard />}
                                />
                            </Routes>
                        }
                    </div>
                    <Footer />
                </>
            </PrivilegeProvider>
        </ProvideRemember>
    );
}
